import classes from './ContentContainer.module.css'


const ContentContainer = ({ children }) => <div className={classes.container}>{children}</div>


export default ContentContainer;